import DetailsTable from './DetailsTable';
import CardTable from './CardTable';
import HorizontalCardIconFactory from '../shared/HorizontalCardIconFactory';
import MicroIcon from '../shared/MicroIcon';
import Icon from 'components/Icon';

const Micro = MicroIcon(Icon.OPTIONS.TABLE);

export const icon = Micro;
export const card = CardTable;
export const details = DetailsTable;
export const micro = Micro;
export const horizontal = HorizontalCardIconFactory(Micro);
export const preview = CardTable;
